import { jsx as _jsx } from "react/jsx-runtime";
import { BarGraphics } from "./BarGraphics";
import { BoxReturn } from "./BoxReturn";
import { BubbleChat } from "./BubbleChat";
import { BubbleInfo } from "./BubbleInfo";
import { CakeGraphic } from "./CakeGraphic";
import { Calendar } from "./Calendar";
import { Clock } from "./Clock";
import { Clock24Hs } from "./Clock24Hs";
import { ClockArrows } from "./ClockArrows";
import { Conversation } from "./Conversation";
import { CreditCards } from "./CreditCards";
import { Flame } from "./Flame";
import { Funnel } from "./Funnel";
import { Heart } from "./Heart";
import { Lightbulb } from "./Lightbulb";
import { LightbulbOK } from "./LightbulbOK";
import { MapLocation } from "./MapLocation";
import { MapMark } from "./MapMark";
import { Megaphone } from "./Megaphone";
import { PaperPlane } from "./PaperPlane";
import { Ranking } from "./Ranking";
import { Recognition } from "./Recognition";
import { Security } from "./Security";
import { Shop } from "./Shop";
import { ShoppingBag } from "./ShoppingBag";
import { Smartphone } from "./Smartphone";
import { Tag } from "./Tag";
import { Target } from "./Target";
import { ThumbUp } from "./ThumbUp";
import { Truck } from "./Truck";
import { Wallet } from "./Wallet";
import { Write } from "./Write";
export const misc = {
    barGraphics: _jsx(BarGraphics, {}, void 0),
    boxReturn: _jsx(BoxReturn, {}, void 0),
    bubbleChat: _jsx(BubbleChat, {}, void 0),
    bubbleInfo: _jsx(BubbleInfo, {}, void 0),
    cakeGraphic: _jsx(CakeGraphic, {}, void 0),
    calendar: _jsx(Calendar, {}, void 0),
    clock: _jsx(Clock, {}, void 0),
    clock24Hs: _jsx(Clock24Hs, {}, void 0),
    clockArrows: _jsx(ClockArrows, {}, void 0),
    conversation: _jsx(Conversation, {}, void 0),
    creditCards: _jsx(CreditCards, {}, void 0),
    clame: _jsx(Flame, {}, void 0),
    cunnel: _jsx(Funnel, {}, void 0),
    ceart: _jsx(Heart, {}, void 0),
    lightbulb: _jsx(Lightbulb, {}, void 0),
    lightbulbOK: _jsx(LightbulbOK, {}, void 0),
    mapLocation: _jsx(MapLocation, {}, void 0),
    mapMark: _jsx(MapMark, {}, void 0),
    megaphone: _jsx(Megaphone, {}, void 0),
    paperPlane: _jsx(PaperPlane, {}, void 0),
    ranking: _jsx(Ranking, {}, void 0),
    recognition: _jsx(Recognition, {}, void 0),
    security: _jsx(Security, {}, void 0),
    shop: _jsx(Shop, {}, void 0),
    shoppingBag: _jsx(ShoppingBag, {}, void 0),
    smartphone: _jsx(Smartphone, {}, void 0),
    tag: _jsx(Tag, {}, void 0),
    target: _jsx(Target, {}, void 0),
    thumbUp: _jsx(ThumbUp, {}, void 0),
    truck: _jsx(Truck, {}, void 0),
    wallet: _jsx(Wallet, {}, void 0),
    write: _jsx(Write, {}, void 0),
};
//# sourceMappingURL=index.js.map